<template>
	<header class="header">
		<div class="header_row">
			<div class="wrapper">
				<router-link to="/" class="header_logo">
					<img src="/img/logo.png" alt="">
					<span>КИБЕРПОРТАЛ</span>
				</router-link>
				<div class="header_btn"><i></i><i></i><i></i></div>
				
				<menu-list class-name="header_menu-list"></menu-list>
			</div>
		</div>
		
		<div class="header_menu">
			<div class="header_menu-top">
				<div class="header_menu-close"></div>
			</div>
			<menu-list class-name="header-nav"></menu-list>
		</div>
	</header>
</template>

<script>
	import MenuList from "./MenuList";
	
	export default {
		components: {
			MenuList
		}
	}
</script>

<style scoped>

</style>